<template>
  <div>
    <span class="failure">{{ failureMessage }}</span>
    <b-tabs v-model="activeTabIndex" @input="onTabSelected" content-class="mt-3">
      <b-tab title="General">
        <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
          <b-col>
            <div class="content">
              <b-row cols="1" cols-sm="1" cols-md="3" cols-lg="3" cols-xl="3">
                <b-col>
                  <h4>{{ deployment.name }}</h4>
                  Created by: {{ deployment.user.name }}
                </b-col>
                <b-col class="center-align">
                  Status:
                  <span v-if="deployment.status === 'running'" class="success">App is running</span>
                  <span v-else class="failure">App is stopped</span>
                  <br>
                  <br>
                  <a :href="`https://${deployment.domain}`" target="_blank">https://{{ deployment.domain }}</a>
                </b-col>
                <b-col class="center-align">
                  <div v-if="deployment.status === 'running'" class="inline margin">
                    <c-button :onClick="onViewAppLogs" variant="primary">View app logs</c-button>
                  </div>
                  <div v-if="deployment.status === 'running'" class="inline margin">
                    <c-button :onClick="viewMetrics" variant="primary">View metrics</c-button>
                  </div>
                </b-col>
              </b-row>
              <br>
              <br>
              <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="2" cols-xl="2">
                <b-col>
                  <div>
                    <div>
                      <b>DNS Setup</b>
                      <br>
                      <div>
                        <br>
                        <div v-if="(deployment.cloudflareSetup.status === 'active' && mode === 'prod' ? deployment.cloudflareSetup.validationRecord.status === 'active' : true) || (deployment.cloudflareSetup.validationRecord && deployment.cloudflareSetup.validationRecord.status)">
                          <b v-if="deployment.cloudflareSetup.status !== 'active' || deployment.cloudflareSetup.validationRecord.status !== 'active'">
                            Enter the following setting at your DNS provider, then click on 'Update DNS':
                            <br>
                          </b>
                          <div class="table-wrapper">
                            <table>
                              <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Value</th>
                              </tr>
                              <tr>
                                <td>{{ dnsSetup.loadBalancer.name }}</td>
                                <td>CNAME</td>
                                <td>{{ dnsSetup.loadBalancer.value }}</td>
                              </tr>
                              <tr>
                                <td>{{ dnsSetup.certAutoRenew.name }}</td>
                                <td>CNAME</td>
                                <td>{{ dnsSetup.certAutoRenew.value }}</td>
                              </tr>
                            </table>
                          </div>
                          <br>
                          <br>
                          Status: 
                          <span v-if="deployment.cloudflareSetup.status === 'active' && deployment.cloudflareSetup.validationRecord.status === 'active'" class="success">Active</span>
                          <span v-else class="info">Pending</span>
                          <br>
                          <div v-if="this.dnsSetup.status" class="failure">
                            {{ this.dnsSetup.status }}
                          </div>
                          <c-button v-if="deployment.cloudflareSetup.status !== 'active' || deployment.cloudflareSetup.validationRecord.status !== 'active'" :onClick="onUpdateDnsSettings" variant="primary">Update DNS</c-button>
                        </div>
                        <div v-else>
                          <div v-if="this.dnsSetup.status" class="failure">
                            {{ this.dnsSetup.status }}
                          </div>
                          <c-button :onClick="onUpdateDnsSettingsFirstTime" variant="primary">View DNS Settings</c-button>
                        </div>
                      </div>
                    </div>
                    <div class="margin-top-50">
                      <h5>Update app</h5>
                      <div v-if="user.hasGithubAccessToken && !userMustReconnectGithub">
                        <b-form>
                          <b-form-group id="name" label="App name" label-for="name">
                            <b-form-input 
                              id="name"
                              v-model="form.name.value"
                              :state="form.name.error.state"
                              readonly
                              type="text"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="form.name.error.state">
                              {{ form.name.error.value }}
                            </b-form-invalid-feedback>
                          </b-form-group>

                          <b-form-group id="repo" label="Choose repo" label-for="repo">
                            <multiselect
                              v-model="form.repo.value"
                              :options="repos"
                              placeholder="Search for a repo"
                              select-label=""
                              :multiple="false"
                              :searchable="true"
                              :hide-selected="false"
                            >
                            </multiselect>
                            <b-form-invalid-feedback :state="form.repo.error.state">
                              {{ form.repo.error.value }}
                            </b-form-invalid-feedback>
                          </b-form-group>

                          <b-form-group id="branch" :label="`Enter branch to deploy`" label-for="branch">
                            <b-form-input
                              id="branch"
                              v-model="form.branch.value"
                              :state="form.branch.error.state"
                              type="text"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="form.branch.error.state">
                              {{ form.branch.error.value }}
                            </b-form-invalid-feedback>
                          </b-form-group>

                          <b-form-group id="language" label="Choose language" label-for="language">
                            <b-form-radio 
                              v-model="form.language.value"
                              name="language-radio"
                              value="node"
                            >
                              Node.js
                            </b-form-radio>

                            <b-form-radio 
                              v-model="form.language.value"
                              name="language-radio"
                              value="ruby"
                            >
                              Ruby
                            </b-form-radio>

                            <b-form-radio 
                              v-model="form.language.value"
                              name="language-radio"
                              value="python"
                            >
                              Python
                            </b-form-radio>
                            
                            <b-form-radio 
                              v-model="form.language.value"
                              name="language-radio"
                              value="php"
                            >
                              PHP
                            </b-form-radio>
                            <b-form-invalid-feedback :state="form.language.error.state">
                              {{ form.language.error.value }}
                            </b-form-invalid-feedback>
                          </b-form-group>

                          <b-form-group id="version" :label="`Enter ${form.language.value} version`" label-for="version">
                            <b-form-input
                              id="version"
                              v-model="form.version.value"
                              :state="form.version.error.state"
                              type="text"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="form.version.error.state">
                              {{ form.version.error.value }}
                            </b-form-invalid-feedback>
                          </b-form-group>

                          <b-form-group id="folder" label="Enter folder name where app is located" label-for="folder" description="Leave root if app is located at root">
                            <b-form-input
                              id="folder"
                              v-model="form.folder.value"
                              :state="form.folder.error.state"
                              type="text"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="form.folder.error.state">
                              {{ form.folder.error.value }}
                            </b-form-invalid-feedback>
                          </b-form-group>

                          <b-form-group id="install" label="Enter install command" label-for="install">
                            <b-form-input
                              id="install"
                              v-model="form.install.value"
                              :state="form.install.error.state"
                              type="text"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="form.install.error.state">
                              {{ form.install.error.value }}
                            </b-form-invalid-feedback>
                          </b-form-group>

                          <b-form-group id="start" label="Enter start command" label-for="start">
                            <b-form-input
                              id="start"
                              v-model="form.start.value"
                              :state="form.start.error.state"
                              type="text"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="form.start.error.state">
                              {{ form.start.error.value }}
                            </b-form-invalid-feedback>
                          </b-form-group>

                          <b-form-group id="port" label="Enter port (on which your app is listening on)" label-for="port">
                            <b-form-input
                              id="port"
                              v-model="form.port.value"
                              :state="form.port.error.state"
                              placeholder="Example: 3000"
                              type="number"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="form.port.error.state">
                              {{ form.port.error.value }}
                            </b-form-invalid-feedback>
                          </b-form-group>

                          <b-form-group id="variables" label="Enter environment variables" label-for="variables" description="Copy paste here the content of your .env file. One variable per line. Don't use any quotes (' or &quot;) around the values">
                            <b-form-textarea
                              id="variables"
                              v-model="form.variables.value"
                              :state="form.variables.error.state"
                              placeholder=
                              'VARIABLE1=test                                                                                                     VARIABLE2=test2'
                              rows="5"
                            ></b-form-textarea>
                            <b-form-invalid-feedback :state="form.variables.error.state">
                              {{ form.variables.error.value }}
                            </b-form-invalid-feedback>
                          </b-form-group>

                          <b-form-group id="domain" label="Enter domain name that will point to the app" label-for="domain" description="Enter domain without https://">
                            <b-form-input
                              id="domain"
                              v-model="form.domain.value"
                              :state="form.domain.error.state"
                              placeholder="Example: app.yourdomain.com"
                              readonly
                              type="text"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="form.domain.error.state">
                              {{ form.domain.error.value }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-form>

                        <c-button :onClick="onSubmit" variant="primary">Update and deploy</c-button>
                        <br>
                        <span class="success">{{ formSuccess }}</span>
                        <span class="failure">{{ formFailure }}</span>
                      </div>

                      <div v-else class="center-align">
                        <c-button :onClick="onConnect" variant="transparent" :keepLoading="true">
                          <img class="logo" src="../../public/github.png" width="300px">
                        </c-button>
                      </div>
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <div class="right-align">
                    <c-button v-if="deployment.status === 'stopped' && (deploymentAttempts[0] && deploymentAttempts[0].status === 'succeeded')" :onClick="newDeploymentAttempt" variant="primary">
                      Launch app
                    </c-button>
                    <c-button v-else-if="deployment.status === 'running' && (deploymentAttempts[0] && deploymentAttempts[0].status !== 'inprogress')" :onClick="pauseDeployment" variant="primary">
                      Pause app
                    </c-button>
                    <c-button v-else-if="(deploymentAttempts[0] && deploymentAttempts[0].status === 'failed')" :onClick="newDeploymentAttempt" variant="primary">
                      Re-deploy app
                    </c-button>
                  </div>
                  <br>
                  <h5>Builds</h5>
                  <b-table :fields="deploymentAttemptsTable" :items="deploymentAttempts" responsive="sm">
                    <template #cell(createdAt)="data">
                      {{ data.item.createdAt | datetime }}
                    </template>
                    <template #cell(region)="data">
                      {{ data.item.region }}
                    </template>
                    <template #cell(status)="data">
                      <span v-if="data.item.status === 'succeeded'" class="text-green">{{ data.item.status | status }}</span>
                      <span v-else-if="data.item.status === 'failed'" class="text-red">{{ data.item.status | status }}</span>
                      <span v-else-if="data.item.status === 'inprogress'">
                        <fa-icon icon="spinner" spin />
                        {{ data.item.status | status }}
                      </span>
                    </template>
                    <template #cell(logs)="data">
                      <a @click.prevent="viewDeploymentLogs(data.item.deploymentAttemptId)">View build logs</a>
                    </template>
                  </b-table>
                  <div class="center-align">
                    <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'listDeploymentAttempts', 'deploymentAttemptsPagination')"/>
                      Page: {{ deploymentAttemptsPagination.page }} / {{ deploymentAttemptsPagination.totalPages }}
                    <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'listDeploymentAttempts', 'deploymentAttemptsPagination')"/>
                  </div>
                  <div class="margin-top-50">
                    <h5 class="inline">Historic usage</h5> (last {{ deploymentTimeTrackingsLimit }} months)
                    <b-table class="margin-top" :fields="deploymentTimeTrackingsTable" :items="deploymentTimeTrackings" responsive="sm">
                      <template #cell(month)="data">
                        {{ data.item._id.month | month }} {{ data.item._id.year }}
                      </template>
                      <template #cell(totalValue)="data">
                        {{ data.item.totalValue | cost2Decimals }}€
                        <span v-if="(data.item._id.month === (new Date().getUTCMonth() + 1)) && (data.item._id.year === (new Date().getUTCFullYear()))"> (Estimated)</span>
                      </template>
                      <template #cell(details)="data">
                        <a @click.prevent="viewTimeTrackingDetails(data.item._id.month, data.item._id.year)">View details</a>
                      </template>
                    </b-table>
                    <span v-if="new Date(user.freeTrialEndAt) > new Date()">Usage will appear after free trial is over</span>
                  </div>
                </b-col>
              </b-row>
              <b-row class="margin-top-50" cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
                <b-col>
                  <h5>Danger Zone</h5>
                  <br>
                  <c-button :onClick="deleteDeployment" variant="danger">Delete app</c-button>
                  <br>
                  <span class="success">{{ deleteDeploymentSuccessMessage }}</span>
                  <span class="failure">{{ deleteDeploymentFailureMessage }}</span>
                </b-col>
              </b-row>
            </div>
          </b-col>

          <b-modal id="timeTrackingDetails" size="xl" title="Usage details" hide-footer>
            <div class="d-block">
              <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
                <b-col>
                  <h5>{{ timeTrackingDetails.month | month }} {{ timeTrackingDetails.year }}</h5>
                  <b-table :fields="deploymentTimeTrackingsMonthYearTable" :items="deploymentTimeTrackingsMonthYear" responsive="sm">
                    <template #cell(region)="data">
                      {{ data.item.deploymentLocation.region }}
                    </template>
                    <template #cell(size)="data">
                      {{ data.item.size | size }}
                    </template>
                    <template #cell(scale)="data">
                      {{ data.item.scale }}
                    </template>
                    <template #cell(value)="data">
                      {{ getMinutesFromValue(data.item.value, data.item.scale, data.item.size) }} minutes
                      <span v-if="data.item.current && (timeTrackingDetails.month === (new Date().getUTCMonth() + 1)) && (timeTrackingDetails.year === (new Date().getUTCFullYear()))"> (Estimated)</span>
                    </template>
                    <template #cell(cost)="data">
                      {{ data.item.value | cost3Decimals }}€
                      <span v-if="data.item.current && (timeTrackingDetails.month === (new Date().getUTCMonth() + 1)) && (timeTrackingDetails.year === (new Date().getUTCFullYear()))"> (Estimated)</span>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </div>
          </b-modal>

          <b-modal id="deploymentLogs" size="xl" title="Build logs" hide-footer>
            <div class="d-block">
              <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
                <b-col>
                  <b>Status: </b>
                  <span v-if="deploymentStatus === 'succeeded'" class="text-green">{{ deploymentStatus | status }}</span>
                  <span v-else-if="deploymentStatus === 'failed'" class="text-red">{{ deploymentStatus | status }}</span>
                  <span v-else-if="deploymentStatus === 'inprogress'">
                    <fa-icon icon="spinner" spin />
                    {{ deploymentStatus | status }}
                  </span>
                  <br>
                  <br>
                  <b-form-textarea v-model="deploymentLogs" plaintext id="deploymentLogsTextarea" rows="20" cols="100"></b-form-textarea>
                </b-col>
              </b-row>
            </div>
          </b-modal>

          <b-modal id="appLogs" @hidden="closeAppLogsModal" size="xl" title="App logs" hide-footer>
            <div class="d-block">
              <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
                <b-col>
                  <b-form-textarea v-model="appLogs" plaintext id="appLogsTextarea" rows="20" cols="100"></b-form-textarea>
                </b-col>
              </b-row>
            </div>
          </b-modal>

          <b-modal id="metrics" size="xl" title="Metrics" hide-footer>
            <div class="d-block">
              <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
                <b-col>
                  <b>Region: </b>
                  <select v-model="selectedDeploymentLocation" @change="listMetrics({ resetSelectedContainerNumber: true })">
                    <option 
                      v-for="deploymentLocation in deploymentLocations"
                      :key="deploymentLocation.id"
                      :value="deploymentLocation"
                    >
                      {{ deploymentLocation.region }}
                    </option>
                  </select>
                  <br>
                  <b>Container number: </b>
                  <select v-model="selectedContainerNumber" @change="listMetrics()">
                    <option 
                      v-for="n in selectedDeploymentLocation.scale"
                      :key="n"
                      :value="n"
                    >
                      {{ n }}
                    </option>
                  </select>
                  <br>
                  <br>
                  <iframe v-if="metricsUrls.cpuUsage" :src="metricsUrls.cpuUsage" width="1200" height="300" frameborder="0"></iframe>
                  <br>
                  <br>
                  <iframe v-if="metricsUrls.memoryUsage" :src="metricsUrls.memoryUsage" width="1200" height="200" frameborder="0"></iframe>
                  <br>
                  <br>
                  <iframe v-if="metricsUrls.memoryCached" :src="metricsUrls.memoryCached" width="1200" height="200" frameborder="0"></iframe>
                  <br>
                  <br>
                  <iframe v-if="metricsUrls.memoryUsage" :src="metricsUrls.receivedNetworkTraffic" width="1200" height="200" frameborder="0"></iframe>
                  <br>
                  <br>
                  <iframe v-if="metricsUrls.sentNetworkTraffic" :src="metricsUrls.sentNetworkTraffic" width="1200" height="200" frameborder="0"></iframe>
                </b-col>
              </b-row>
            </div>
          </b-modal>
        </b-row>
      </b-tab>
      <b-tab
        v-for="(location, index) in deploymentLocations"
        :key="location.id"
        :title="location.region"
      >
        <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
          <b-col>
            <div class="content">
              <b-row cols="1" cols-sm="1" cols-md="2" cols-lg="2" cols-xl="2">
                <b-col>
                  <b-form>
                    <b-form-group id="scale" label="" label-for="scale">
                      <b>Scale app</b>
                      <b-form-input 
                        v-model="location.scale"
                        type="range"
                        min="1"
                        max="10"
                      ></b-form-input>
                      <span>Replicated {{ location.scale }} time(s)</span>
                      <b-form-invalid-feedback :state="formScale.scale.error.state">
                        {{ formScale.scale.error.value }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-form>
                  <c-button :onClick="() => onScale(location.id, location.scale, index)" variant="primary">Scale</c-button>
                  <b-form class="margin-top-50">
                    <b-form-group id="size" label-for="size">
                      <b>Update size (<router-link :to="{ name: 'Pricing'}" target="_blank">view pricing</router-link>)</b>
                      <br>
                      <b-form-radio 
                        class="inline margin-2"
                        v-model="location.size"
                        name="xs-radio"
                        value="128"
                      >
                        XS (128MB)
                      </b-form-radio>
                      <b-form-radio 
                        class="inline margin-2"
                        v-model="location.size"
                        name="s-radio"
                        value="256"
                      >
                        S (256MB)
                      </b-form-radio>
                      <b-form-radio 
                        class="inline margin-2"
                        v-model="location.size"
                        name="m-radio"
                        value="512"
                      >
                        M (512MB)
                      </b-form-radio>
                      <b-form-radio 
                        class="inline margin-2"
                        v-model="location.size"
                        name="l-radio"
                        value="1024"
                      >
                        L (1024MB)
                      </b-form-radio>
                      <b-form-radio 
                        class="inline margin-2"
                        v-model="location.size"
                        name="xl-radio"
                        value="2048"
                      >
                        XL (2048MB)
                      </b-form-radio>
                      <b-form-radio 
                        class="inline margin-2"
                        v-model="location.size"
                        name="xxl-radio"
                        value="4096"
                      >
                        XXL (4096MB)
                      </b-form-radio>
                      <b-form-radio 
                        class="inline margin-2"
                        v-model="location.size"
                        name="xxxl-radio"
                        value="8192"
                      >
                        XXXL (8192MB)
                      </b-form-radio>
                      <b-form-invalid-feedback :state="formSize.size.error.state">
                        {{ formSize.size.error.value }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-form>
                  <c-button :onClick="() => onSizeUpdate(location.id, location.size, index)" variant="primary">Update</c-button>
                </b-col>
                <b-col>
                  <div>
                    <h5>Last container shutdown</h5>
                    <b-table :fields="shutdownContainersTable" :items="shutdownContainers" responsive="sm" thead-class="d-none">
                      <template #cell(state)="data">
                        {{ data.item.state }}
                        <span v-if="data.item.state.includes('137')"> => Container ran out of memory. Consider increasing your app size</span>
                      </template>
                    </b-table>
                    <span v-if="shutdownContainers.length === 0">No container was recently shutdown</span>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>

  import CButton from '@/components/Button'
  import { PaginationModule } from '../utils.js'
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'Deployment',
    components: { CButton, Multiselect },
    props: {
      id: String,
      start: Boolean
    },
    data() {
      return {
        activeTabIndex: 0,
        failureMessage: '',
        deleteDeploymentFailureMessage: '',
        deleteDeploymentSuccessMessage: '',
        pauseDeploymentFailureMessage: '',
        pauseDeploymentSuccessMessage: '',
        deployment: {},
        dnsSetup: {
          status: '',
          loadBalancer: {},
          certAutoRenew: {}
        },
        deploymentLocations: [],
        deploymentAttempts: [],
        deploymentAttemptsMapping: {},
        deploymentAttemptsPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null,
          payload: null
        },
        deploymentAttemptsTable: [
          {
            key: 'createdAt',
            label: 'Started at'
          },
          {
            key: 'region'
          },
          {
            key: 'status'
          },
          {
            key: 'logs'
          }
        ],
        shutdownContainers: [],
        shutdownContainersTable: [
          {
            key: 'state'
          }
        ],
        deploymentLogs: '',
        deploymentStatus: '',
        displayDeploymentLogsFromDeploymentAttemptId: null,
        appLogs: '',
        form: {
          name: {
            value: '',
            error: {}
          },
          repo: {
            value: '',
            error: {}
          },
          branch: {
            value: '',
            error: {}
          },
          language: {
            value: '',
            error: {}
          },
          version: {
            value: '',
            error: {}
          },
          folder: {
            value: '',
            error: {}
          },
          install: {
            value: '',
            error: {}
          },
          start: {
            value: '',
            error: {}
          },
          port: {
            value: '',
            error: {}
          },
          variables: {
            value: '',
            error: {}
          },
          domain: {
            value: '',
            error: {}
          },
        },
        formSuccess: '',
        formFailure: '',
        formScale: {
          scale: {
            value: '',
            error: {}
          },
        },
        scaleFormSuccess: '',
        scaleFormFailure: '',
        formSize: {
          size: {
            value: '',
            error: {}
          },
        },
        sizeFormSuccess: '',
        sizeFormFailure: '',
        repos: [],
        userMustReconnectGithub: false,
        deploymentTimeTrackings: [],
        deploymentTimeTrackingsTable: [
          {
            key: 'month',
          },
          {
            key: 'totalValue',
            label: 'Cost'
          },
          {
            key: 'details'
          }
        ],
        deploymentTimeTrackingsLimit: 12,
        timeTrackingDetails: {
          month: null,
          year: null
        },
        deploymentTimeTrackingsMonthYear: [],
        deploymentTimeTrackingsMonthYearTable: [
          {
            key: 'region',
          },
          {
            key: 'size',
          },
          {
            key: 'scale'
          },
          {
            key: 'value',
            label: 'Time'
          },
          {
            key: 'cost'
          }
        ],
        metricsUrls: {},
        selectedContainerNumber: 1,
        selectedDeploymentLocation: {}
      }
    },
    async created() {
      if (this.isLoggedUserQueryDone && !this.user.stripeSetupIntentDone) {
        this.$router.push({ name: 'SetupPayment', params: { deploymentId: this.id } });
      } else {
        await this.getDeployment(this.id)
        await this.listDeploymentLocations()
        await this.listDeploymentAttempts()
        await this.listDeploymentTimeTrackings()
        await this.listUserRepos()

        this.socket.on('appLogs', ({ name, region, message }) => {
          if (name === this.deployment.name) {
            this.appLogs += `${region}: ${message}`
            const appLogsTextarea = document.getElementById('appLogsTextarea')
            appLogsTextarea.scrollTop = appLogsTextarea.scrollHeight 
          }
        })

        this.socket.on('deploymentLogs', async ({ name, deploymentAttemptId, region, message, status }) => {
          if (name === this.deployment.name) {
              let deploymentAttemptsIndex = this.deploymentAttemptsMapping[deploymentAttemptId]
              if(deploymentAttemptsIndex === undefined) {
                for(let i = 0; i < this.deploymentAttempts.length; i++) {
                  const deploymentAttempt = this.deploymentAttempts[i]
                  if(!deploymentAttempt.deploymentAttemptId && deploymentAttempt.region === region) {
                    deploymentAttempt.deploymentAttemptId = deploymentAttemptId
                    this.deploymentAttemptsMapping[deploymentAttemptId] = i
                    deploymentAttemptsIndex = i
                  }
                }
              }
              this.deploymentAttempts[deploymentAttemptsIndex].logs += message
              this.deploymentAttempts[deploymentAttemptsIndex].status = status
              if(this.displayDeploymentLogsFromDeploymentAttemptId === deploymentAttemptId) {
                this.deploymentLogs += message
                this.deploymentStatus = status
              }
              const deploymentLogsTextarea = document.getElementById('deploymentLogsTextarea')
              if(deploymentLogsTextarea) deploymentLogsTextarea.scrollTop = deploymentLogsTextarea.scrollHeight
          }
        })

        this.socket.on('deploymentUpdate', async ({ deploymentId, status }) => {
          if (deploymentId === this.id) {
            this.deployment.status = status
            await this.listDeploymentTimeTrackings()
          }
        })

        if (this.start) {
          await this.newDeploymentAttempt()
        }
      }
    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
      isLoggedUserQueryDone() {
        return this.$store.state.isLoggedUserQueryDone;
      },
      cname() {
        return `${this.deployment.domain} CNAME ${this.loadBalancer}`
      },
      mode() {
        return process.env.VUE_APP_MODE
      }
    },
    methods: {
      async getDeployment(id) {
        this.failureMessage = ''
        this.deployment = {}

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/getDeployment.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            deploymentId: id
          }
        });

        if (result.errors) {
          for (const error of result.errors) {
            if(error.message && error.message === 'StripeSetupIntent not setup') {
              this.$router.push({ name: 'SetupPayment', params: { deploymentId: this.id } })
            }
          }
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getDeployment && result.data.getDeployment.deployment) {
          this.deployment = Object.assign({}, this.deployment, result.data.getDeployment.deployment)
          for (const prop in result.data.getDeployment.deployment) {
            if (this.form.hasOwnProperty(prop)) {
              this.form[prop].value = result.data.getDeployment.deployment[prop]
            }
          }
          this.dnsSetup.loadBalancer = Object.assign({}, this.dnsSetup.loadBalancer, result.data.getDeployment.loadBalancer)
          this.dnsSetup.certAutoRenew = Object.assign({}, this.dnsSetup.certAutoRenew, result.data.getDeployment.certAutoRenew)
        }
      },
      async getDeploymentLocation(deploymentLocationId, index) {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/getDeploymentLocation.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            deploymentLocationId
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getDeploymentLocation && result.data.getDeploymentLocation.id) {
          this.$set(this.deploymentLocations, index, result.data.getDeploymentLocation)
        }
      },
      async listDeploymentLocations() {
        this.failureMessage = ''
        this.deploymentLocations = []

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/listDeploymentLocations.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            deploymentId: this.id,
            page: 1,
            itemsPerPage: 1000
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listDeploymentLocations && result.data.listDeploymentLocations.deploymentLocations) {
          this.deploymentLocations = result.data.listDeploymentLocations.deploymentLocations.map(location => ({
            ...location
          }))
        }
      },
      async validateCustomHostname(id, shallDisplayMessage) {
        this.failureMessage = ''
        this.dnsSetup = {}

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/validateCustomHostname.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            deploymentId: id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.validateCustomHostname && result.data.validateCustomHostname.deployment) {
          this.deployment.cloudflareSetup = Object.assign({}, this.deployment.cloudflareSetup, result.data.validateCustomHostname.deployment.cloudflareSetup)
          this.dnsSetup.loadBalancer = Object.assign({}, this.dnsSetup.loadBalancer, result.data.validateCustomHostname.loadBalancer)
          this.dnsSetup.certAutoRenew = Object.assign({}, this.dnsSetup.certAutoRenew, result.data.validateCustomHostname.certAutoRenew)
        }

        if (this.deployment.cloudflareSetup.validationRecord.status !== 'active' && shallDisplayMessage) {
          this.dnsSetup.status = 'We could not validate your domain. Please try again in 1 minute.'
        }
      },
      async onUpdateDnsSettings(status) {
        const shallDisplayMessage = true 
        await this.validateCustomHostname(this.id, shallDisplayMessage)
      },
      async onUpdateDnsSettingsFirstTime() {
        const shallDisplayMessage = false
        await this.validateCustomHostname(this.id, shallDisplayMessage)
      },
      async deleteDeployment() {
        if (confirm('Are you sure you want to delete this app? Everything will be deleted. This action is irreversible')) {
          this.failureMessage = ''

          const result = await this.$apollo.mutate({
            client: 'private',
            mutation: require('@/graphql/deleteDeployment.graphql'),
            fetchPolicy: 'no-cache',
            variables: {
              deploymentId: this.id
            }
          });

          if (result.errors) {
            const e = result;
            if (e.body) {
              if (e.body.message) {
                this.failureMessage = e.body.message;
              }
            }
          }

          if (result && result.data && result.data.deleteDeployment && result.data.deleteDeployment.deleted) {
            this.deleteDeploymentSuccessMessage = "App successfully deleted!"
            this.$router.push({ name: 'Deployments' });

          } else {
            this.deleteDeploymentFailureMessage = "Error while deleting the app"
          }
        }
      },
      async pauseDeployment() {
        this.failureMessage = ''

        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/pauseDeployment.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            deploymentId: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.pauseDeployment && result.data.pauseDeployment.id) {
          this.pauseDeploymentSuccessMessage = "App successfully paused!"
          await this.getDeployment(this.id)
          await this.listDeploymentTimeTrackings()

        } else {
          this.pauseDeploymentFailureMessage = "Error while pausing the app"
        }
      },
      async listDeploymentAttempts() {
        this.failureMessage = ''
        this.deploymentAttempts = []

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/listDeploymentAttempts.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            deploymentId: this.id,
            page: this.deploymentAttemptsPagination.page,
            itemsPerPage: this.deploymentAttemptsPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listDeploymentAttempts) {
          for (let i = 0; i < result.data.listDeploymentAttempts.deploymentAttempts.length; i++) {
            const deploymentAttempt = result.data.listDeploymentAttempts.deploymentAttempts[i]
            const logs = deploymentAttempt.logs.join('')
            const newLength = this.deploymentAttempts.push({
              deploymentAttemptId: deploymentAttempt.id,
              createdAt: deploymentAttempt.createdAt,
              region: deploymentAttempt.deploymentLocation.region,
              status: deploymentAttempt.status,
              logs
            })
            this.deploymentAttemptsMapping[deploymentAttempt.id] = newLength - 1
          }
          this.deploymentAttemptsPagination.count = result.data.listDeploymentAttempts.pagination.count
          this.deploymentAttemptsPagination.totalPages = result.data.listDeploymentAttempts.pagination.totalPages
        }
      },
      async listDeploymentTimeTrackings() {
        this.failureMessage = ''
        this.deploymentTimeTrackings = []

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/listDeploymentTimeTrackings.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            deploymentId: this.id,
            limit: this.deploymentTimeTrackingsLimit
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listDeploymentTimeTrackings) {
          this.deploymentTimeTrackings = result.data.listDeploymentTimeTrackings
        }
      },
      async getDeploymentTimeTracking() {
        this.failureMessage = ''
        this.deploymentTimeTrackingsMonthYear = []

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/getDeploymentTimeTracking.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            deploymentId: this.id,
            month: this.timeTrackingDetails.month,
            year: this.timeTrackingDetails.year
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getDeploymentTimeTracking) {
          this.deploymentTimeTrackingsMonthYear = result.data.getDeploymentTimeTracking
        }
      },
      async newDeploymentAttempt() {
        this.socket.emit('deploy', { deploymentId: this.id })
        const logs = 'Logs will appear here very soon...'
        const status = 'inprogress'
        for(let i = 0; i < this.deploymentLocations.length; i++) {
          const deploymentLocation = this.deploymentLocations[i]
          this.deploymentAttempts.unshift({
            region: deploymentLocation.region,
            logs,
            status,
            createdAt: new Date()
          })

          //since we added one item in the this.deploymentAttempts array using unshift, we also have to change the values in this.deploymentAttemptsMapping
          this.deploymentAttemptsMapping = Object.fromEntries(
            Object.entries(this.deploymentAttemptsMapping).map(([key, value]) => [key, value + 1])
          )
        }
      },
      newDeploymentAttemptAtLocation({ deploymentLocationId, index }) {
        this.socket.emit('deployAtLocation', { deploymentId: this.id, deploymentLocationId })
        const logs = 'Logs will appear here very soon...'
        const status = 'inprogress'
        this.deploymentAttempts.unshift({
          region: this.deploymentLocations[index].region,
          logs,
          status,
          createdAt: new Date()
        })

        //since we added one item in the this.deploymentAttempts array using unshift, we also have to change the values in this.deploymentAttemptsMapping
        this.deploymentAttemptsMapping = Object.fromEntries(
          Object.entries(this.deploymentAttemptsMapping).map(([key, value]) => [key, value + 1])
        )
      },
      async viewTimeTrackingDetails(month, year) {
        this.timeTrackingDetails.month = month
        this.timeTrackingDetails.year = year
        await this.getDeploymentTimeTracking()
        this.showModal('timeTrackingDetails')
      },
      async viewMetrics() {
        this.selectedDeploymentLocation = this.deploymentLocations[0]
        this.selectedContainerNumber = 1
        await this.listMetrics()
        this.showModal('metrics')
      },
      viewDeploymentLogs(deploymentAttemptId) {
        this.displayDeploymentLogsFromDeploymentAttemptId = deploymentAttemptId
        const deploymentAttemptsIndex = this.deploymentAttemptsMapping[deploymentAttemptId]
        this.deploymentLogs = this.deploymentAttempts[deploymentAttemptsIndex].logs
        this.deploymentStatus = this.deploymentAttempts[deploymentAttemptsIndex].status
        this.showModal('deploymentLogs')
      },
      viewAppLogs() {
        this.showModal('appLogs')
      },
      onViewAppLogs() {
        this.appLogs = ''
        this.socket.emit('attach', { deploymentId: this.id })
        this.viewAppLogs()
      },
      closeAppLogsModal() {
        this.socket.emit('stopViewAppLogs')
      },
      pagination(type, funcToExecute, obj) {
        const paginationModule = PaginationModule();
        const newPage = paginationModule.changePage(type, this[obj].page, this[obj].totalPages);
        if (newPage) {
          this[obj].page = newPage;
          this[funcToExecute](this[obj].payload);
        }
      },
      showModal(id) {
        this.$bvModal.show(id)
      },
      hideModal(id) {
        this.$bvModal.hide(id)
      },
      async onConnect(event) {
        const response = await this.$http.get(process.env.VUE_APP_API_BASE_URL + `/github/auth?id=${this.id}`)

        if (response && response.body && response.body.authUrlWeb) {
          window.location.href = response.body.authUrlWeb;
        } else {
          throw(new Error('Could not redirect to Github log in page'))
        }
      },
      async listUserRepos() {
        try {
          const response = await this.$http.get(process.env.VUE_APP_API_BASE_URL + "/github/repos")

          if (response.body && response.body.repos) {
            this.repos = response.body.repos
          }
        } catch(e) {
          if (e.body) {
            if (e.body.message && e.body.message.includes('User must reconnect')) {
              this.userMustReconnectGithub = true
            }
          }
        }
      },
      async listMetrics({ resetSelectedContainerNumber } = {}) {
        this.failureMessage = ''
        this.metricsUrls = []

        if(resetSelectedContainerNumber) {
          this.selectedContainerNumber = 1
        }

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/listMetrics.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            deploymentId: this.id,
            deploymentLocationId: this.selectedDeploymentLocation.id,
            containerNumber: this.selectedContainerNumber
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listMetrics) {
          this.metricsUrls = Object.assign({}, this.metricsUrls, result.data.listMetrics)
        }
      },
      async listShutdownContainers(deploymentLocationId) {
        this.failureMessage = ''
        this.shutdownContainers = []

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/listShutdownContainers.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            deploymentId: this.id,
            deploymentLocationId
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.listShutdownContainers) {
          this.shutdownContainers = result.data.listShutdownContainers
        }
      },
      async onSubmit(event) {
        for (let key in this.form) {
          this.form[key].error = {}
        }
        this.formSuccess = ''
        this.formFailure = ''

        const body = {
          deploymentId: this.id,
          repo: this.form.repo.value,
          branch: this.form.branch.value,
          language: this.form.language.value,
          version: this.form.version.value,
          folder: this.form.folder.value,
          install: this.form.install.value,
          start: this.form.start.value,
          port: Number(this.form.port.value),
          variables: this.form.variables.value,
        }

        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/updateDeployment.graphql'),
          variables: body
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.formFailure = e.body.message;
            }
            if (e.body.details) {
              e.body.details.map(detail => {
                detail.path.map(path => {
                  this.$set(this.form[path], 'error', {state: false, value: detail.message})
                })
              })
            }
          }
        } else {
          if (result && result.data && result.data.updateDeployment && result.data.updateDeployment.id) {
            await this.getDeployment(this.id)
            await this.newDeploymentAttempt()
          }
        }
      },
      async onScale(deploymentLocationId, scale, index) {
        for (let key in this.formScale) {
          this.formScale[key].error = {}
        }
        this.scaleFormSuccess = ''
        this.scaleFormFailure = ''

        const body = {
          deploymentId: this.id,
          deploymentLocationId: deploymentLocationId,
          scale: Number(scale)
        }

        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/scaleDeployment.graphql'),
          variables: body
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.scaleFormFailure = e.body.message;
            }
            if (e.body.details) {
              e.body.details.map(detail => {
                detail.path.map(path => {
                  this.$set(this.formScale[path], 'error', {state: false, value: detail.message})
                })
              })
            }
          }
        } else {
          if (result && result.data && result.data.scaleDeployment && result.data.scaleDeployment.id) {
            await this.listDeploymentTimeTrackings()
          }
        }
        await this.getDeploymentLocation(deploymentLocationId, index)
      },
      async onSizeUpdate(deploymentLocationId, size, index) {
        for (let key in this.formSize) {
          this.formSize[key].error = {}
        }
        this.sizeFormSuccess = ''
        this.sizeFormFailure = ''

        const body = {
          deploymentId: this.id,
          deploymentLocationId: deploymentLocationId,
          size: Number(size)
        }

        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/updateDeploymentLocationSize.graphql'),
          variables: body
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.sizeFormFailure = e.body.message;
            }
            if (e.body.details) {
              e.body.details.map(detail => {
                detail.path.map(path => {
                  this.$set(this.formSize[path], 'error', {state: false, value: detail.message})
                })
              })
            }
          }
        } else {
          if (result && result.data && result.data.updateDeploymentLocationSize && result.data.updateDeploymentLocationSize.id) {
            this.newDeploymentAttemptAtLocation({ deploymentLocationId, index })
            this.activeTabIndex = 0
          }
        }
        await this.getDeploymentLocation(deploymentLocationId, index)
      },
      getMinutesFromValue(value, scale, size) {
        return value / scale / (size / 128)
      },
      async onTabSelected(newActiveTabIndex) {
        this.scaleFormFailure = ''
        this.$set(this.formScale.scale, 'error', {})
        this.sizeFormFailure = ''
        this.$set(this.formSize.size, 'error', {})

        if(this.deploymentLocations[newActiveTabIndex - 1] && this.deploymentLocations[newActiveTabIndex - 1].id) await this.listShutdownContainers(this.deploymentLocations[newActiveTabIndex - 1].id)
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
  .table-wrapper {
    overflow-x: auto;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    min-width: 600px; /* optional: avoids collapsing too much */
  }

  th, td {
    border: 1px solid #ccc;
    padding: 8px;
    white-space: nowrap; /* disables wrapping */
  }
</style>
